import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput.js'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import WebComponent from '../../WebComponent.js'
import I18n from '../../i18n.js'
import StammdatenService from '../../services/StammdatenService.js'
import AdminService from '../../services/AdminService.js'

export default class TechnischeKapazitaet extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'technische-kapazitaet-reload-triggered'
    }
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
        margin-bottom: -15px;
      }

      .title-content {
        display: flex;
        gap: 1em;
        margin-bottom: 0.5em;
        align-items: center;
      }

      .form-inline {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        width: 70%;
        align-items: center;
      }

      .einspeisepunkt {
        flex: 3;
      }

      .mwhh {
        flex: 1;
      }

      .bemerkung {
        flex: 4;
      }
    `
  }

  get translationFile() {
    return './views/Admin/i18n.json'
  }

  constructor() {
    super()
    this.adminService = new AdminService()
    this.stammdatenService = new StammdatenService()
    this.data = {}
    this.nextUrl = ''
  }

  connectedCallback() {
    super.connectedCallback()

    this._refresh = () => {
      send(TechnischeKapazitaet.EVENT_KEYS.RELOAD_TRIGGERED)
      this._loadData()
    }
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)

    this._loadData()
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
  }

  _loadData() {
    this.adminService.list('kapazitaet/technisch')
      .then(kapazitaeten => {
        this.data = kapazitaeten
        this.render()
      })
      .catch(_ => this.reload())
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('admin.technische.kapazitaet.header')}">
        <nav class="kapazitaet-title-navigation">
          <isceco-button
            id="kapazitaet-speichern"
            variant="primary"
            size="small"
            icon="save"
            @click="${_ => {
              if (document.getElementById("kapazitaet-form").validate()) {
                document.getElementById('kapazitaet-confirm-dialog').removeAttribute('hidden')
              }
            }}"
          ></isceco-button>
        </nav>
      </isceco-title>
      <p>${this.i18n.translate('admin.technische.kapazitaet.aktualisiert')} ${this.getModTime()}</p>

      <isceco-form id="kapazitaet-form"
                   prevent-navigation
                   @abort="${event => this.handleAbort(event)}"
      >
        <div slot="form-elements">
          <div class="form-inline">
            <div class="einspeisepunkt"><p>
              <b>${this.i18n.translate('admin.technische.kapazitaet.grid.header.einspeisepunkt')}</b></p></div>
            <div class="mwhh"><p><b>${this.i18n.translate('admin.technische.kapazitaet.grid.header.mwhh')}</b></p></div>
            <div class="bemerkung"><p>
              <b>${this.i18n.translate('admin.technische.kapazitaet.grid.header.bemerkungen')}</b></p></div>
          </div>
          ${this.data.map((kapazitaet, index) => html`
            <div class="form-inline">
              <div class="einspeisepunkt">${kapazitaet.bezeichnung}</div>
              <div class="mwhh">
                <isceco-number-input
                  required
                  name="${kapazitaet.code}-value"
                  maximum-fraction-digits="0"
                  min="0"
                  value="${kapazitaet.value}"
                  @change="${e => this.updateValue(index, 'value', e)}">
                </isceco-number-input>
              </div>
              <div class="bemerkung">
                <isceco-text-input
                  name="${kapazitaet.code}-bemerkung"
                  value="${kapazitaet.bemerkung}"
                  @change="${e => this.updateValue(index, 'bemerkung', e)}">
                </isceco-text-input>
              </div>
            </div>
          `)}
        </div>
      </isceco-form>

      <isceco-dialog
        hidden
        header="${this.i18n.translate('admin.technische.kapazitaet.confirm.header')}"
        id="kapazitaet-confirm-dialog"
        confirm-button="${this.i18n.translate('admin.technische.kapazitaet.confirm.confirm')}"
        Cancel-button="${this.i18n.translate('admin.technische.kapazitaet.confirm.cancel')}"
        @submit="${confirmed => this._close(confirmed)}">
      </isceco-dialog>
      <isceco-dialog id="abort-dialog"
                     hidden
                     header="${this.i18n.translate('admin.confirm.changes.dialog.titel')}"
                     description="${this.i18n.translate('admin.confirm.changes.dialog.beschreibung')}"
                     confirm-button="${this.i18n.translate('admin.confirm.changes.dialog.bestaetigen')}"
                     cancel-button="${this.i18n.translate('admin.confirm.changes.dialog.abbrechen')}"
                     @submit="${event => this.confirmAbort(event)}"
      ></isceco-dialog>
    `
  }

  getModTime() {
    const modDates = this.data.map(obj => new Date(obj.modificationDate))
    return html`${formatDateTime(Math.max.apply(null, modDates))}`
  }

  updateValue(index, key, event) {
    this.data[index][key] = event.detail.value
  }

  _close(e) {
    e.target.hidden = true
    if (e.detail.confirmed) {
      this._save()
    }
  }

  _save() {
    this.adminService.updateList(this.data, 'kapazitaet/technisch')
      .then(() => {
        // Reset the valueChanged from the form inputs, data are already saved in another way
        const formElements = document.querySelector('#kapazitaet-form').getFormElements();
        if (formElements) {
          formElements.forEach(element => {element.valueChanged = false})
        }
        showAlert(this.i18n.translate('admin.technische.kapazitaet.createupdate.success'), '', 'success')
        this._refresh()
      })
      .catch(() => {
        showAlert(this.i18n.translate('admin.technische.kapazitaet.createupdate.failure'), '', 'error')
        this.render()
      })
  }

  handleAbort = event => {
    const dialog = document.querySelector('#abort-dialog')
    dialog.hidden = false
    this.nextUrl = event.detail.url ?? '#Cockpit'
  }

  confirmAbort = event => {
    if (event.detail.confirmed) {
      navigate({to: this.nextUrl, allow: true})
    } else {
      event.target.hidden = true
    }
  }
}
customElements.define('gasmonitoring-frontend-admin-technische-kapazitaet', TechnischeKapazitaet)
